import eventBus from 'js/eventBus';

export const manageListCellSelection = (viewModel, selectedObjects) => {
    if (selectedObjects.length > 0) {
        const selectedObject = selectedObjects[0];
        const { data, dispatch } = viewModel;
        if (selectedObject.cellType === 'Project' || selectedObject.cellType === 'Folder') {
            const crumbCount = data.dynamicCrumbs.length;
            if (crumbCount >= 1) {
                data.dynamicCrumbs[crumbCount - 1].selectedCrumb = false;
            }
            const crumb = {
                clicked: false,
                displayName: selectedObject.name,
                selectedCrumb: true,
                showArrow: true,
                cellType: selectedObject.cellType,
                relUID: selectedObject.relUID //
            };
            crumb.onCrumbClick = function (selectedCrumb, event) {
                // onclick publish event with crumbindex and selectedCrumb
                eventBus.publish('NavigateProjectContentsAsList.breadCrumbSelected', { crumbIndex: crumbCount, crumb: selectedCrumb });
            };
            // add createdCrumb to dynamicCrumbs field
            data.dynamicCrumbs = [...data.dynamicCrumbs, crumb];

            // if project clicked set
            if (selectedObject.cellType === 'Project') {
                data.selectedProjectId.dbValue = selectedObject.relUID;
            } else if (selectedObject.cellType === 'Folder') {
                data.selectedFolderId.dbValue = selectedObject.relUID;
            }

            // reset search value when project or folder clicked.
            data.textValue.dbValue = null;
        }

        // update state (i.e data in afx-next-react)
        dispatch({ path: 'data', value: { ...data } });
    }
};

export const manageCrumbSelection = (viewModel, crumbIndex) => {
    const { data, dispatch } = viewModel;

    data.dynamicCrumbs = data.dynamicCrumbs.slice(0, crumbIndex + 1);
    data.dynamicCrumbs[crumbIndex].selectedCrumb = true;

    if (data.dynamicCrumbs[crumbIndex].cellType === 'Project') {
        data.selectedFolderId.dbValue = null;
    } else if (data.dynamicCrumbs[crumbIndex].cellType === 'Folder') {
        data.selectedFolderId.dbValue = data.dynamicCrumbs[crumbIndex].relUID;
    }

    data.textValue.dbValue = null;
    dispatch({ path: 'data', value: { ...data } });
};

export const refreshViewModel = (viewModel) => {
    const { data, dispatch } = viewModel;
    data.selectedProjectId.dbValue = null;
    data.selectedFolderId.dbValue = null;
    data.dynamicCrumbs = [];
    data.projectsSkip = 0;
    data.projectContentsSkip = 0;
    data.textValue.dbValue = null;

    // update state (i.e data in afx-next-react)
    dispatch({ path: 'data', value: { ...data } });
}

export const resetSkipVals = (viewModel) => {
    const { data, dispatch } = viewModel;
    data.projectsSkip = 0;
    data.projectContentsSkip = 0;

    dispatch({ path: 'data', value: { ...data } });
}
